import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";

const PendingApplications = () => {
  return (
    <DashboardLayout pageTitle="Pending Applications" mainClass="p-6">
      <AdminApplications
        title="Pending Applications"
        status={null}
        stage={null}
        pending={true}
      />
    </DashboardLayout>
  );
};

export default PendingApplications;
